import { Link } from "react-router-dom";

export default function Footer() {
    return(
<>

        <div className="container-fluid bg-dark text-light mt-5 wow fadeInUp" data-wow-delay="0.1s">
        <div className="container">
            <div className="row gx-5">
               
                <div className="col-lg-8 col-md-6">
                    <div className="row gx-5">
                        <div className="col-lg-4 col-md-12 pt-5 mb-5">
                            <div className="section-title section-title-sm position-relative pb-3 mb-4">
                                <h3 className="text-light mb-0">Contáctanos</h3>
                            </div>
                            <div className="d-flex mb-2">
                                <i className="bi  bi-whatsapp text-primary me-2"></i>
                                <a href="https://wa.me/+541161361408" target="_blank" rel="noopener noreferrer">
                
                                WhatSapp
            </a>
                          
                            </div>
                            <div className="d-flex mb-2">
                                <i className="bi bi-envelope-open text-primary me-2"></i>
                                <a href="mailto:info@elaritech.com" target="_blank" rel="noopener noreferrer">info@elaritech.com</a>
                            </div>
                            <div className="d-flex mb-2">
                                <i className="bi bi-telephone text-primary me-2"></i>
                                <a href="tel:+541161361408 "class="mb-0" target="_blank" rel="noopener noreferrer">+54 11 6136 1408</a>
                            </div>
                            <div className="d-flex mt-4">
                                <a className="btn btn-primary btn-square me-2" target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/profile.php?id=61572272330417"><i className="fab fa-facebook-f fw-normal"></i></a>
                     {/*            <a className="btn btn-primary btn-square" href="#"><i className="fab fa-instagram fw-normal"></i></a> */}
                            </div>
                        </div>
                  
                        <div className="col-lg-4 col-md-12 pt-0 pt-lg-5 mb-5">
                            <div className="section-title section-title-sm position-relative pb-3 mb-4">
                                <h3 className="text-light mb-0">Menu</h3>
                            </div>
                            <div className="link-animated d-flex flex-column justify-content-start">
                                <Link className="text-light mb-2" to="/"><i className="bi bi-arrow-right text-primary me-2"></i>Inicio</Link>
                                <Link className="text-light mb-2" to="/sobre-nosotros"><i className="bi bi-arrow-right text-primary me-2"></i>Sobre Nosotros</Link>
                                <Link className="text-light mb-2" to="/nuestros-servicios"><i className="bi bi-arrow-right text-primary me-2"></i>Servicios</Link>
                                <Link className="text-light mb-2" to="/contáctanos"><i className="bi bi-arrow-right text-primary me-2"></i>Contáctanos</Link>
                                <Link className="text-light mb-2" to="/cotización" ><i className="bi bi-arrow-right text-primary me-2"></i>Solicitar Cotización</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <p className="mb-0  text-center">&copy; Copyright © ELARITECH.
					</p>


    </div>

</>
    )
}